import { getCdnUrl } from "@repo/shared"

import { env } from "../../env"

const cdn = (): string => {
	return getCdnUrl({
		NEXT_PUBLIC_DEPLOY_CDN: env.NEXT_PUBLIC_DEPLOY_CDN,
		NEXT_PUBLIC_DEPLOY_HOST: env.NEXT_PUBLIC_DEPLOY_HOST,
		NEXT_PUBLIC_DEPLOY_VERSION: env.NEXT_PUBLIC_DEPLOY_VERSION,
		NEXT_PUBLIC_DEPLOY_SUFFIX: env.NEXT_PUBLIC_DEPLOY_SUFFIX,
	})
}

export { cdn }
